import React from 'react';
import "../../CSS/App.css";

function DeclarationModal() {
    
    return (
        <div className="Declaration-frame">
            <h1>COPYRIGHT WILL LIAO 2025</h1>
            <h2>TECHNICAL STACK</h2>
            <ul>
                <li><b>Frontend:</b> React 17, TypeScript, HTML5, CSS3</li>
                <li><b>Build Tools:</b> Create React App, Webpack 5</li>
                <li><b>Libraries:</b> react-scroll, react-spring, react-intersection-observer, ts-particles</li>
                <li><b>Performance:</b> Lazy loading, image optimization, video intersection observers</li>
                <li><b>Hosting:</b> Amazon Web Services (S3, CloudFront, Route 53)</li>
                <li><b>AI Development Tools:</b> Cursor AI, Bolt.new, ChatGPT</li>
            </ul>
            <h2>CONTENT SOURCES</h2>
            <ul>
                <li><b>Icons:</b> icons8.com, custom SVG assets</li>
                <li><b>Typography:</b> Google Fonts (Inter, Poppins)</li>
                <li><b>Images:</b> Original photography and design work</li>
                <li><b>Videos:</b> Original drone footage from Tam'sui, Taiwan</li>
            </ul>
        </div>
    )
}

export default DeclarationModal;